import { useEffect, useRef, useState } from 'react';

/**
 * True once the element has come near the screen (and stays true): lets a row
 * wait with its network work, such as an avatar, until someone can see it.
 * Without IntersectionObserver (tests, old browsers) it is true at once.
 */
export function useSeen<T extends Element>(margin = '200px') {
  const ref = useRef<T | null>(null);
  const [seen, setSeen] = useState(() => typeof IntersectionObserver === 'undefined');
  useEffect(() => {
    const el = ref.current;
    if (seen || !el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (!entries.some((e) => e.isIntersecting)) return;
        io.disconnect();
        setSeen(true);
      },
      { rootMargin: margin },
    );
    io.observe(el);
    return () => io.disconnect();
  }, [seen, margin]);
  return { ref, seen };
}
